import { render, staticRenderFns } from "./JobsApplicationsCountPerDurationCard.vue?vue&type=template&id=204cd2ad&"
import script from "./JobsApplicationsCountPerDurationCard.vue?vue&type=script&lang=js&"
export * from "./JobsApplicationsCountPerDurationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports